import { Select } from 'components/Select/Select';
import { SEARCH_RADIUS_RADIO_OR_SELECT_OPTIONS } from 'utils/constants/general/searchRadiuses';

type Props = {
  radius: string;
  setSearchRadius: (radius: string) => void;
  includeState: boolean;
  includeCountry: boolean;
};

export function SearchRadiusSelector({
  radius,
  setSearchRadius,
  includeState,
  includeCountry,
}: Props) {
  if (!setSearchRadius) {
    return null;
  }

  let radiusOptions = SEARCH_RADIUS_RADIO_OR_SELECT_OPTIONS()[CURRENT_LOCALE()];

  if (!includeCountry) {
    radiusOptions = radiusOptions.filter(
      (option) => option.value !== 'country',
    );
  }
  if (!includeState) {
    radiusOptions = radiusOptions.filter((option) => option.value !== 'state');
  }

  return (
    <Select
      label={getText('Search radius')}
      name="radius"
      value={radius}
      options={radiusOptions}
      onChange={(newValue) => newValue && setSearchRadius(newValue.value)}
      data-qa-id="search-radius-selector"
    />
  );
}
